import styled from "styled-components/macro";

export const StyledContainer = styled.button`
  position: relative;
  background: linear-gradient(to right, var(--primary-cta-active) 50%, var(--primary-cta) 50%) !important;
  background-size: 200% 100% !important;
  background-position: right bottom !important;
  transition: all 0s ease-out;
  white-space: nowrap;

  &.filling {
    background-position: left bottom !important;
    transition: background-position ${(props) => props.seconds}s ease-out;
    opacity: 0.5 !important;
    cursor: auto !important;
    /*
    &:disabled {
      background: linear-gradient(to right, var(--primary-cta-light) 50%, var(--primary-cta) 50%) !important;
      background-position: left bottom !important;
      transition: background-position ${(props) => props.seconds}s ease-out;
    } */
  }

  &.disabled {
    background: var(--button-disabled) !important;

    &:hover {
      opacity: 1;
    }
  }

  &:hover {
    opacity: 0.75;
  }

  .spinner {
    position: absolute;
    right: -50px;
    top: 4px;
    width: 30px;
    height: 30px;
    margin: 0 10px 0px auto;
    /* align-self: center; */
  }
`;
